// extracted by mini-css-extract-plugin
module.exports = {"cardView":"CardView_cardView__3K9KI","noClubs":"CardView_noClubs__7sSYF","desktop_div":"CardView_desktop_div__15Gen","mobile_div":"CardView_mobile_div__2GdIM"};